import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import './TabBar.css'
import React, { useRef, useEffect, useState, useCallback } from 'react';
import CensusContent from './CensusContent.js'
import PropertyContent from './PropertyContent.js'



export default function TabBar(props) {

  return (
    <div>
      {
        (props.census) && <CensusContent census={props.census}></CensusContent>

      }
      { (props.parcel && props.searchResult != "") && <PropertyContent parcel={props.parcel}></PropertyContent>
      }
      </div>

  );
}